import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ButtonPrimary } from '@aftersale-next/ui';
import { colors, When, LoadingDot } from '@aftersale-next/ui';
import * as trackingActions from '../../config/constants/tracking-actions';
export default function ActionNotReceived(_ref) {
  var isLoading = _ref.isLoading,
      mutate = _ref.mutate,
      id = _ref.id;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(ButtonPrimary, {
    id: trackingActions.NOT_RECEIVED,
    disabled: isLoading,
    bgColor: colors.red,
    onClick: function onClick() {
      return mutate({
        action: trackingActions.NOT_RECEIVED,
        id: id
      });
    },
    children: [/*#__PURE__*/_jsx(When, {
      value: !isLoading,
      children: t('ACTION_NOT_RECEIVED')
    }), /*#__PURE__*/_jsx(When, {
      value: isLoading,
      children: /*#__PURE__*/_jsx(LoadingDot, {})
    })]
  });
}